import axios from 'axios';
import { Prod01 } from '../../constants/ActionType';

const base = () => `${Prod01}/care-team`;
const data = (r) => r.data;

const careTeamApi = {
    patient: (patientId) => axios.get(`${base()}/patient/${patientId}`).then(data),
    people: (kind = 'nurse', organizationId) =>
        axios.get(`${base()}/people`, { params: { kind, ...(organizationId && { organizationId }) } }).then(data),
    peopleFor: (kind, patientIds) => axios.post(`${base()}/people`, { kind, patientIds }).then(data),
    nursePatients: (hrId) => axios.get(`${base()}/nurse/${hrId}/patients`).then(data),
    assignable: (nurseId) => axios.get(`${base()}/assignable-patients`, { params: { nurseId } }).then(data),
    preview: (body) => axios.post(`${base()}/preview`, body).then(data),
    apply: (body) => axios.post(`${base()}/apply`, body).then(data),
    undo: (batchId) => axios.post(`${base()}/undo/${batchId}`).then(data),
};

export const errorText = (e) => e?.response?.data?.message || e?.message || 'Something went wrong';

export default careTeamApi;
